var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1749 5.44728C14.4439 4.98513 14.2831 4.39486 13.8158 4.12886C13.3485 3.86287 12.7516 4.02189 12.4827 4.48404L12.0136 5.29012L11.5444 4.48404C11.2755 4.02189 10.6786 3.86287 10.2113 4.12886C9.744 4.39486 9.58321 4.98513 9.85217 5.44728L10.8871 7.22562L7.61355 12.8505H4.97627C4.43709 12.8505 4 13.2828 4 13.816C4 14.3493 4.43709 14.7815 4.97627 14.7815H14.1622C14.2427 14.5722 14.3275 14.2131 14.2373 13.8831C14.1017 13.3869 13.6 12.8505 12.7593 12.8505H9.8664L14.1749 5.44728Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12125 15.8492C7.95468 15.6662 7.58148 15.3739 7.25424 15.2777C6.75526 15.131 6.377 15.223 6.18615 15.3032L5.45895 16.5527C5.18999 17.0149 5.35078 17.6051 5.81809 17.8711C6.28539 18.1371 6.88226 17.9781 7.15122 17.516L8.12125 15.8492Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5374 14.7815H19.0237C19.5629 14.7815 20 14.3493 20 13.816C20 13.2828 19.5629 12.8505 19.0237 12.8505H16.4136L13.4734 7.79844C13.2549 8.00371 12.8362 8.52811 12.7729 9.12265C12.6915 9.887 12.8136 10.5307 13.1797 11.1609C14.4105 13.2799 15.6433 15.3979 16.8759 17.516C17.1449 17.9781 17.7417 18.1371 18.209 17.8711C18.6763 17.6051 18.8371 17.0149 18.5682 16.5527L17.5374 14.7815Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AC9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F65EB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.6d97c5dcce6bbe38844af3330a823ee5.svg";
export { ForwardRef as ReactComponent };